export default { SERVER_ADDRESS: window.location.origin, SOCKET_PATH: "/literature-assistent/socket.io" };



// WEBPACK FOOTER //
// ./src/config.ts